module.exports = __webpack_public_path__ + "img/video-4.00957f1a.jpg";